import BaseProjectIdApi from "../BaseProjectIdApi";

export default abstract class BaseConfigApi extends BaseProjectIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/config`;
	}
}
